/* eslint-disable @typescript-eslint/no-explicit-any */
import { status } from './StatusCalculator';
import SidebarSecondStatuses from '../resources/enums/SidebarSecondStatuses';
import { requestSendGlobalNotification } from '../store/users/actions';
import { DocumentData, DocumentReference, getDoc } from 'firebase/firestore';
import { Dispatch } from 'redux';

export const sendNotification = async (
    newItem: any,
    document: DocumentReference<DocumentData>,
    type: string,
    dispatch: Dispatch<any>,
) => {
    const docData = await getDoc(document);
    const prevStatus = status(docData?.data()?.publishTo, docData?.data()?.publishFrom);
    const nextStatus = status(newItem.publishTo, newItem.publishFrom);
    if (prevStatus !== SidebarSecondStatuses.active && nextStatus === SidebarSecondStatuses.active)
        dispatch(requestSendGlobalNotification(type));
};
